<sk-checkbox
  stylingMode="unformed"
  data-test="dms-grid-checkbox-header-template"
  [formControl]="valueControl"
  [indeterminate]="indeterminate()"
></sk-checkbox>

<div class="selection-menu-trigger" [matMenuTriggerFor]="selectionMenu"></div>

<mat-menu
  #selectionMenu="matMenu"
  class="iris-module-menu selection-module-menu"
  (closed)="menuClosed($event)"
  xPosition="after">
  <button
    mat-menu-item
    (click)="selectCurrentPage()"
    data-test="dms-grid-checkbox-header-template-button"
  >
    <span>{{'label.grid.SelectCurrentPage' | translate}}</span>
  </button>

  <button
    mat-menu-item
    (click)="selectAllPages()"
    data-test="dms-grid-checkbox-header-template-button-2"
  >
    <span>{{ 'label.grid.SelectAllPages' | translate }}</span>
  </button>
</mat-menu>
